export const TABLE_CONTROL_BUTTONS_ACTIONS_SELECT_OPTION_VALUE = {
  changeViewType: 'changeViewType',
  config: 'config',
  density: 'density',
  refresh: 'refresh',
  resetSorting: 'resetSorting',
}

export const CHANGE_VIEW_TYPE_SCREEN_MIN_WIDTH = 848 // px

export const QA_NAME_TABLE_CONTROL_BUTTONS_MENU = 'controlActionsMenu'

export const QA_NAME_TABLE_CONTROL_BUTTONS_SECTION = 'controlButtons'
